var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('InfoBox',{attrs:{"id":"setup.company.intro_text"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('setup.company.intro_text'))}})]),_c('CompanyForm',{attrs:{"value":_vm.selectedCompany},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }